import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { approveMultipleWithComment, getQuotaForApproval, rejectMultiple, setState } from "./quotaApprovalSlice";
import { Button, TextField, Typography } from "@mui/material";

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 400,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 2,
   borderRadius: 1,
};

export default function ApproveWithCommentModal() {
   const dispatch = useDispatch();
   const {
      appMulWithCommentModal,
      appMulWithComment,
      selectedRows,
      selectedRowsselected,
      quotaForApprovalTable,
      quotaForApproval,
      selectedCountryID,
      selectedPeriod,
      selectedQuotaStatus,
      searchText
   } = useSelector((store) => store.quota);

   function handleClose() {
      dispatch(setState("appMulWithCommentModal", false));
      dispatch(setState("appMulWithComment",""));
   }

   function setComment(event) {
      const comment = event.target.value;
      dispatch(setState("appMulWithComment", comment));
   }

   function search() {
      dispatch(setState("quotaCustomerBreakdown", null));
      dispatch(setState("quotaDetailsTable", null));
		dispatch(setState("rejectSelectedComment",''));
		dispatch(setState("selectedRows",[]));
      dispatch(setState("appMulWithComment",""));
      const logedUser = JSON.parse(localStorage.getItem("data"));
      const countryId = selectedCountryID;
      const period = selectedPeriod;
      const quotaStatus = selectedQuotaStatus;

      const obj = {
         countryId,
         period,
         quotaStatus,
         logedUser,
         searchText: searchText
      };
      dispatch(getQuotaForApproval(obj));
   }

   // function approveSelected() {
   //    handleClose();

   //    const user = JSON.parse(localStorage.getItem("data"));
   //    let quotaList = [];
   //    for (let i = 0; i < selectedRows.length; ++i) {
   //       const id = quotaForApprovalTable.rows[selectedRows[i]].quotaId;
   //       let quota = quotaForApproval.find((item) => item.quotaId === id);
   //       quota = {
   //          ...quota,
   //          approveComments: appMulWithComment,
   //       }
   //       const obj = {
   //          ...quota,
   //          user,
   //       };
   //       quotaList.push(obj);
   //    }
   //    console.log("Approve_Quota_ApproveSelectedWithComment", quotaList);
   //    dispatch(approveMultipleWithComment(quotaList)).then(() =>
   //    {
   //       search();
   //    });
   // }

   function approveSelected() {
      handleClose();

      const user = JSON.parse(localStorage.getItem("data"));
      let qtaLst = [];
      for (let i = 0; i < selectedRowsselected.length; ++i) {
        let quota = quotaForApproval.find(
          (item) => item.quotaId === selectedRowsselected[i].quotaId
        );
        quota = {
         ...quota,
         approveComments: appMulWithComment,
      }
        console.log(quota);
        const obj = {
          ...quota,
          user,
        };
        qtaLst.push(obj);
      }
      console.log("Approve_Quota_ApproveSelected", qtaLst);
      dispatch(approveMultipleWithComment(qtaLst)).then(() => {
        search();
        dispatch(setState("isCheckboxChecked", false));
      });
    }

   return (
      <Box>
         <Modal open={appMulWithCommentModal} onClose={handleClose}>
            <Box sx={style}>
               <Typography variant="subtitle2">Comments</Typography>
               <TextField
                  className={'fullWidth'}
                  size="large"
                  multiline
                  rows={6}
                  style={{overflowY:'auto'}}
                  value={appMulWithComment}
                  onChange={setComment}
               />
               <br />
               <Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<Button
                     sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        mt: 1,
								mr: 2,
                        "&:hover": {
                        bgcolor: "darkred.main",
                        color: "white.main",
                        },
                     }}
							onClick={handleClose}
						>
							Close
						</Button>

						<Button
                     sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        mt:1,
                        "&:hover": {
                        bgcolor: "darkred.main",
                        color: "white.main",
                        },
                     }}
							onClick={approveSelected}
						>
							Approve
						</Button>
					</Box>
            </Box>
         </Modal>
      </Box>
   );
}
